import { TuiInput, TuiRadio } from '@taiga-ui/core';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { type FormQuestionState } from '@pixacare/forms';
import { TuiBlock, TuiChevron, TuiDataListWrapper, TuiSelect } from '@taiga-ui/kit';
import { FormDisplayMode } from '../../form-grid/models/form-display-mode';

@Component({
  selector: 'pxc-form-question-radio',
  templateUrl: './form-question-radio.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, TuiInput, TuiBlock, TuiRadio, TuiChevron, TuiDataListWrapper, TuiSelect],
})
export class FormQuestionRadioComponent {
  private readonly translocoService = inject(TranslocoService);

  readonly control = input.required<AbstractControl>();
  readonly question = input.required<FormQuestionState>();
  readonly mode = input<FormDisplayMode>('form');
  readonly readOnly = input<boolean>(false);

  readonly isGrid = computed(() => this.mode() === 'grid');

  readonly choiceKeys = computed(() => this.question().choices?.map((c) => c.key) ?? []);
  readonly placeholder = computed(
    () => this.question().parameters?.placeholder ?? this.translocoService.translate('Choisir une réponse'),
  );

  private readonly choiceLabels = computed(() => {
    const map = new Map<string, string>();
    for (const choice of this.question().choices ?? []) {
      map.set(choice.key, choice.value);
    }
    return map;
  });

  readonly stringifyChoice = (key: string): string => this.choiceLabels().get(key) ?? key;
}
